import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import queryString from 'query-string'

import { Title, Note, Button } from 'components/misc'
import { Header, LayoutPlain } from 'components/layout'
import { meta } from 'helpers/decorators'
import { payment } from 'redux/modules/api'
import config from 'config'

@meta({
  title: 'Participant registration fees payment',
  intlKey: 'moduleTitle.payment'
})
@connect(null, {
  setPaymentResponse: payment.setPaymentResponse
})
class PaymentSuccess extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    setPaymentResponse: PropTypes.func.isRequired
  }

  componentWillMount = () => {
    const query = queryString.parse(get(this.props, 'location.search'))
    const authCode = get(query, 'authorizationCode')

    if (authCode) {
      this.props.setPaymentResponse(authCode)
    }
  }

  render() {
    return (
      <LayoutPlain greyBg header={<Header />}>
        <Title
          h1
          intlKey="moduleTitle.payment_successful"
          className="base-margin--top"
        >
          Participant registration payment was successful
        </Title>
        <strong>
          <Note intlKey="label.registration_updated">
            This registration has been updated.
          </Note>
        </strong>
        <Note intlKey="label.award_leader_receive_payment">
          The Award Leader will receive information about the payment.
        </Note>
        <br />
        <Button link to={`${config.publicPath}/`} intlKey="button.proceed_to_login">
          Proceed to login page
        </Button>
      </LayoutPlain>
    )
  }
}

export default PaymentSuccess
